import React from "react";
import ReactApexChart from "react-apexcharts";

const SpakChart1 = ({color}) => {
    const series = [{
        data: [23, 32, 27, 38, 27, 32, 27, 34, 26, 31, 28]
    }];

    const options = {
        chart: {
            type: 'line',
            width: 80,
            height: 35,
            sparkline: {
                enabled: true
            }
        },
        stroke: {
            width: [3],
            curve: 'smooth'
        },
        colors: [color],
        tooltip: {
            enabled: false // Disable the tooltip completely
        }
    };

    return (
        <React.Fragment>
            <ReactApexChart options={options} series={series} type="line" height={35} width={80} />
        </React.Fragment>
    );
};

export default SpakChart1;

export { SpakChart1 }